import i18next from 'i18next';

i18next.addResources('es_CL', 'MiniCartModal', {
  buy: 'Comprar',
  headerTitle: 'Detalle de tu pedido',
  goToCart: 'Ir a pagar'
});
